import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/theme.css'
import './styles/app.css'
import './styles/spel.css'
import './styles/film.css'

const wortel = document.getElementById('wortel')
if (!wortel) throw new Error('Het element #wortel staat niet in index.html')

createRoot(wortel).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
